import { PagedTableResponse } from './access-users.model';

export interface EvConnectorTypeRowDto {
  id: number;
  code?: string | null;
  name?: string | null;
  nameEn?: string | null;
  description?: string | null;
  sortOrder?: number | null;
  active?: boolean;
  createDate?: string | null;
  writeDate?: string | null;
}

export interface EvConnectorTypeRow {
  id: number;
  code: string;
  name: string;
  nameEn: string;
  description: string;
  sortOrder: number | null;
  active: boolean;
  createDate: string | null;
  writeDate: string | null;
}

export type EvConnectorTypeTableDto = PagedTableResponse<EvConnectorTypeRowDto>;

export interface EvConnectorTypeTableQuery {
  page?: number;
  pageSize?: number;
  search?: string;
}

export interface InsertEvConnectorTypePayload {
  userId: number;
  menuId: number;
  code: string;
  name: string;
  nameEn?: string | null;
  description?: string | null;
  sortOrder?: number | null;
  active: boolean;
}

export interface UpdateEvConnectorTypePayload extends InsertEvConnectorTypePayload {
  id: number;
}

export interface DeactivateEvConnectorTypePayload {
  userId: number;
  menuId: number;
  id: number;
}

export const EV_CONNECTOR_CODE_OPTIONS = [
  { value: 'ac', label: 'AC' },
  { value: 'dc', label: 'DC' },
  { value: 'ac_dc', label: 'AC + DC' },
] as const;
